import { cn, Illustration } from "ui2";

type PublicSafetyPageContainerProps = {
  children: React.ReactNode;
  /** `card` pins the card to the viewport and scrolls inside it; `page` lets the card grow and the page scroll. */
  scroll?: "card" | "page";
};

export const PublicSafetyPageContainer = ({
  children,
  scroll = "card",
}: PublicSafetyPageContainerProps): React.JSX.Element => (
  <div
    className={cn(
      "tw:box-border tw:flex tw:flex-col tw:bg-[url(/dot-texture.png)] tw:min-[800px]:py-10",
      scroll === "card" ? "tw:h-dvh" : "tw:min-h-dvh"
    )}
  >
    <div
      className={cn(
        "tw:max-w-200 tw:mx-auto tw:w-full tw:flex-1 tw:flex tw:flex-col tw:border tw:border-stroke tw:bg-white tw:min-[801px]:shadow-lg",
        scroll === "card" && "tw:min-h-0 tw:overflow-hidden"
      )}
    >
      {children}
    </div>
  </div>
);

type PublicSafetyStatusMessageProps = {
  title: string;
  description: string;
  action?: React.ReactNode;
};

export const PublicSafetyStatusMessage = ({
  title,
  description,
  action,
}: PublicSafetyStatusMessageProps): React.JSX.Element => (
  <div className="tw:flex-1 tw:flex tw:flex-col tw:items-center tw:justify-center tw:p-8 tw:text-center">
    <div className="tw:w-2/3 tw:flex tw:flex-col tw:items-center tw:gap-3">
      <Illustration.Bricks className="tw:size-32" />
      <div className="tw:font-denim tw:text-lg tw:text-midnight">{title}</div>
      <div className="tw:text-sm tw:text-midnight/60">{description}</div>
      {action}
    </div>
  </div>
);
